import { Dialog, DialogContent, Stack } from "@mui/material";
import DialogTitleWithClose from "components/Dialog/DialogTitleWithClose";
import { useTranslations } from "@fenetech/translations";
import React from 'react';
import RelatedOrderLink from "./RelatedOrderLink";
import RelatedQuoteLink from "./RelatedQuoteLink";

interface IProps {
    hasRelatedOrder: boolean,
    mfgOrderNumber: string | undefined,
    hasRelatedQuote: boolean,
    isOpen: boolean,
    onClose: () => void
}

const RelatedLinksDialog: React.FC<IProps> = ({ isOpen, onClose, hasRelatedOrder, mfgOrderNumber, hasRelatedQuote }: IProps) => {

    const tm = useTranslations();

    return <Dialog open={isOpen} onClose={onClose} fullWidth>
        <DialogTitleWithClose onClose={onClose}>{tm.Get("Links")}</DialogTitleWithClose>
        <DialogContent>
            <Stack direction="column" spacing={1} alignItems="flex-start">
                {hasRelatedOrder &&
                    <RelatedOrderLink mfgOrderNumber={mfgOrderNumber} />
                }
                {hasRelatedQuote &&
                    <RelatedQuoteLink />
                }
            </Stack>
        </DialogContent>
    </Dialog>
}

export default RelatedLinksDialog;